import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

import { TranslocoPipe } from '@jsverse/transloco';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';

type Value = unknown;

@Component({
  selector: 'ui-platform-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgIf,
    FormsModule,
    NzCheckboxModule,
    TranslocoPipe
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UiPlatformCheckboxComponent),
      multi: true
    }
  ]
})
export class UiPlatformCheckboxComponent implements ControlValueAccessor {
  @Input() label = '';
  @Input() disabled = false;
  @Input() selectByCheckboxOnly = false;

  internalValue: Value = null;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  syncExternalValue: (value: Value) => void = () => {};
  syncExternalTouched: () => void = () => {};

  onModelChange(value: Value) {
    this.syncExternalValue(value);
    this.syncExternalTouched();
  }

  writeValue(value: Value) {
    this.internalValue = value;
    this.changeDetectorRef.detectChanges();
  }

  registerOnChange(fn: (value: Value) => void) {
    this.syncExternalValue = (value: Value) => {
      fn(value);
    };
  }

  registerOnTouched(fn: () => void) {
    this.syncExternalTouched = () => {
      fn();
    };
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
    this.changeDetectorRef.detectChanges();
  }
}
